import { Component, OnInit } from "@angular/core";
import moment from "moment";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { WorkdayReportService } from "../../workday-report.service";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { locale as italian } from "../../../../i18n/it";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-collaborator-report-view",
  templateUrl: "./collaborator-report-view.component.html",
  styleUrls: ["./collaborator-report-view.component.scss"],
})
export class CollaboratorReportViewComponent implements OnInit {
  public contentHeader: IContentHeader;

  public lastDayCurrentMonth: any = moment().endOf("month").format("DD");

  public newReport: any = { days: {} }; //Sarà contenuto il report generato e anche quello caricato(sia dall'utente che da parte della visualizzazione dello staff

  public available_working_days: Array<number> = [];

  public totalWorkedHours: number = 0;

  public daysOfTheMonth: any = [];

  public previousReports: any = null; //Oggetto che viene sovrascritto nel casto di un get di un report o quando l'utente accede e ha un report già salvato a database

  public unlockDay: any; //Viene riempito con i giorni in cui il report sarà sbloccato

  public lockReport: boolean = false; //Variabile che gestisce il blocco del send

  public today: any = /*"30-03-2023"*/ moment().format("DD-MM-YYYY");

  public currentMonthAndYear: any = moment().format("MMMM YYYY"); //Il mese e anno corrente del report (isStaffMode false)

  public idReport: number = null;

  public statusReport: number = -1;

  public unlockStaffDate: string = null;

  public myProfile: any;

  public daysUnlockReport: any = 5;

  public userStartWorkingInTheCurrentMonth: boolean = false;

  public contractStartDay: number = 0;

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _workdayReport: WorkdayReportService,
    public _routerService: Router,
    public _modalService: NgbModal,
    public _userService: UserService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.YOUR_WORKDAY_REPORT,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.WORKDAY_USER_REPORT",
            isLink: false,
          },
          {
            name: italian.data.MENU.YOUR_WORKDAY_REPORT,
            isLink: false,
          },
        ],
      },
    };
    this.available_working_days = this._utilService.themeConfiguration.working_days; //Parametro gestito da configurazione per i giorni lavorativi
  }

  async ngOnInit() {
    this.daysUnlockReport = this._utilService.themeConfiguration.days_unlock_report;
    this.myProfile = await this._userService.getMe();
    //In caso non sia un collaboratore lo indirizziamo a un altro componente(user-report-view)
    if (this.myProfile.role !== "Collaboratore") {
      await this._routerService.navigateByUrl("/dashboard/workday-report/user-report");
      return false;
    }
    await this.selectReport();
    this._utilService.hideLoading();
  }

  /*Funzione che sceglie se generare un report nel caso non vi siano report salvati a database per il periodo corrente, oppure se presente carica il report del database*/
  async selectReport() {
    this.previousReports = await this._workdayReport.getMineReports();
    this.previousReports = this.previousReports.sort((a, b) => (a.id < b.id ? 1 : -1));
    let isNotNewMonth = this.previousReports.find((report) => report.month == moment().format("MM") && report.year == moment().format("YYYY"));
    if (isNotNewMonth) {
      await this.loadReport(); //Abbiamo trovato il report salvato quindi carichiamo quello(loadReport viene gestita sia per l'utente singolo che per lo staff)
    }
    if (!isNotNewMonth) {
      await this.generateNewReport(); //Non vi sono report salvati quindi generiamo
    }
  }

  async loadReport() {
    this.totalWorkedHours = 0;
    if (moment(this.myProfile.contract_start_date).format("MM-YYYY") === moment().format("MM-YYYY")) {
      this.userStartWorkingInTheCurrentMonth = true;
      this.contractStartDay = Number(moment(this.myProfile.contract_start_date).format("D"));
    }
    this.previousReports = this.previousReports.find((report) => report.month == moment().format("MM") && report.year == moment().format("YYYY")); //Selezioniamo il report del mese
    this.idReport = this.previousReports.id; //Prendiamo l'id del report per gestire l' update o il send report
    this.newReport.days = this.previousReports.report;
    this.daysOfTheMonth = Object.keys(this.newReport.days); /*Array contenente tutti i giorni del mese*/
    this.statusReport = this.previousReports.status; //Prendiamo lo status per nascondere i tasti plus ed edit delle ore singole extra nel caso sia in pending o approvato
    //Calcolo ore totali di lavoro
    this.daysOfTheMonth = Object.keys(this.newReport.days);
    Object.values(this.newReport.days).map((item: any) => {
      this.totalWorkedHours += Number(item.working_hours || 0);
    });
    this.disabledSend();
  }

  async generateNewReport() {
    /**
     * All'avvio della funzione resetto tutte le variabili
     */
    this.totalWorkedHours = 0;
    this.newReport = { days: [] };
    this.previousReports = null;
    ///////////////////////////////
    /**
     * Per ogni giorno del mese corrente effettuiamo un for e andremo a riempire newReport con chiavi
     * dei giorni del mese corrente e setteremo come chiavi Working_hours e absences vuoto per ora (andremo a riempirlo dopo)
     * controlliamo anche se un utente inizia nel mese corrente
     */
    if (moment(this.myProfile.contract_start_date).format("MM-YYYY") === moment().format("MM-YYYY")) {
      this.userStartWorkingInTheCurrentMonth = true;
      this.contractStartDay = Number(moment(this.myProfile.contract_start_date).format("D"));
    }
    for (let i = 1; i <= this.lastDayCurrentMonth; i++) {
      const currentDate = moment(i + "/" + moment().format("MM/YYYY"), "D/MM/YYYY");
      let workingHours: number = this.available_working_days.includes(Number(currentDate.format("d"))) ? 8 : 0;
      workingHours = this._utilService.isHoliday(currentDate) ? 0 : workingHours;
      this.newReport.days[currentDate.format("YYYY-MM-DD")] = Object.assign({
        working_hours: this.userStartWorkingInTheCurrentMonth && Number(currentDate.format("D")) < this.contractStartDay ? 0 : workingHours,
        absences: [],
        extra: { hours: 0, type_id: null },
        extra_km: 0,
        extra_payroll: 0,
        type_name: null,
        addExtraHours: false,
      });
    }
    this.daysOfTheMonth = Object.keys(this.newReport.days); /*Array contenente tutti i giorni del mese*/
    ////////////////////////////////////////////////////////////////////////

    //Calcolo ore totali di lavoro
    this.daysOfTheMonth = Object.keys(this.newReport.days);
    Object.values(this.newReport.days).map((item: any) => {
      this.totalWorkedHours += item.working_hours;
    });
    this.disabledSend();
  }

  //Funzione per gestire i colori della visualizzazione della lista
  isWorkDay(day: string) {
    const dayN: number = Number(moment(day).format("d"));
    return this.available_working_days.includes(dayN);
  }

  async calculateTotalWorkedHours(hour: number, day: string) {
    this.totalWorkedHours = 0;
    //Controllo il valore inserito dall'utente sia valido
    if (!hour || hour < 0 || hour > 24) {
      this.newReport.days[day].working_hours = 0;
      await this._utilService.showSWALError({ text: "ERROR_VALUE_INSERTED_NOT_VALID" });
    }
    this.daysOfTheMonth = Object.keys(this.newReport.days);
    Object.values(this.newReport.days).map((item: any) => {
      this.totalWorkedHours += item.working_hours;
    });
  }

  //Funzione per inserire il report nel database
  async saveReport() {
    const data: any = {
      report: { ...this.newReport.days },
    };
    this._utilService.showLoading();
    await this._workdayReport
      .create(data)
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_SAVE_WORKDAY_REPORT" });
        await this.selectReport();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_SAVE_WORKDAY_REPORT" });
      });
  }

  //Funzione per modificare il report che è già presente nel database
  async updateReport() {
    const data: any = {
      report: { ...this.newReport.days },
      status: 0,
    };
    this._utilService.showLoading();
    await this._workdayReport
      .update(this.idReport, data)
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_WORKDAY_REPORT" });
        await this.selectReport();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_UPDATE_WORKDAY_REPORT" });
      });
  }

  //Funzione invio report (disponibile solamente negli ultimi sette giorni lavorativi) che avrà status uno e quindi lo staff potrà visualizzarlo e decidere se approvare o rifiutare
  async sendReport() {
    const data: any = {
      report: { ...this.newReport.days },
      status: 1,
    };
    this._utilService.showLoading();
    await this._workdayReport
      .update(this.idReport, data)
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_SEND_WORKDAY_REPORT" });
        await this.selectReport();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_SEND_WORKDAY_REPORT" });
      });
  }

  disabledSend() {
    //Controllo se ci sono dimissioni o licenziamenti il rapportino viene sbloccato subito a inizio mese
    if (this.myProfile.closed_at && this.myProfile.closed_at.length > 0 && moment(this.myProfile.closed_at).format("MM/YYYY") === moment().format("MM/YYYY")) {
      this.lockReport = false;
      return false;
    }
    //Controllo la data di fine contratto il rapportino viene sbloccato subito a inizio mese
    if (this.myProfile.contract_end_date && this.myProfile.contract_end_date.length > 0 && moment(this.myProfile.contract_end_date).format("MM/YYYY") === moment().format("MM/YYYY")) {
      this.lockReport = false;
      return false;
    }
    const reportDateMax = this._utilService.themeConfiguration.user_report_max_day; //Oggetto contente per ogni mese la data di sblocco
    const currentMonth = moment().month();
    const currentDay = moment().format("DD");
    //Controllo data dinamica se è a zero entreremo nell'else e calcoleremo la data di sblocco negli ultimi sette giorni lavorativi
    if (reportDateMax && reportDateMax[currentMonth] > 0) {
      this.unlockStaffDate = String(reportDateMax[currentMonth]) + " " + moment().format("MMMM");
      if (Number(currentDay) <= reportDateMax[currentMonth]) {
        this.lockReport = true;
      } else {
        this.lockReport = false;
      }
    } else {
      let array: any = [];
      for (let i = this.lastDayCurrentMonth - 14; i <= this.lastDayCurrentMonth; i++) {
        const date: any = moment(i + "/" + moment().format("MM/YYYY"), "D/MM/YYYY");
        const isWeekEnd: boolean = !this.available_working_days.includes(Number(date.format("d")));
        const isHoliday: boolean = this._utilService.isHoliday(date);
        if (array.length < 14 && !isWeekEnd && !isHoliday) {
          array.push(date);
        }
      }
      this.unlockDay = array[array.length - this.daysUnlockReport]; /*daysUnlockReport parametro gestito dallo staff
            in configurazioni, ad esempio il suo valore è cinque, sara possibile inviare il rapportino cinque giorni lavorativi prima della fine del mese corrente*/
      this.lockReport = moment().subtract(1, "days").diff(this.unlockDay, "day") < 0;
    }
  }
}
